import { createBrowserClient } from '@supabase/ssr';
import type { SupabaseClient } from '@supabase/supabase-js';

let clientInstance: SupabaseClient | null = null;

/**
 * AvenLink browser Supabase client.
 * Uses @supabase/ssr createBrowserClient singleton which manages authentication cookies,
 * token chunking, and session persistence in the browser seamlessly.
 */
export function createClient(): SupabaseClient {
  if (typeof window !== 'undefined' && clientInstance) {
    return clientInstance;
  }

  const rawUrl = process.env.NEXT_PUBLIC_SUPABASE_URL || '';
  const rawKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY || '';

  const url = rawUrl.trim().replace(/\/+$/, '') || 'https://placeholder.supabase.co';
  const anonKey = rawKey.trim() || 'placeholder-anon-key';

  const client = createBrowserClient(url, anonKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  });

  if (typeof window !== 'undefined') {
    clientInstance = client;
  }

  return client;
}
